// PP-403 — explainer card shown at the top of a LIVE listing's drawer. Tells
// the host which edits go through inline-on-live vs. which require pausing
// the listing first and re-entering admin review.
//
// Not shown on paused / paused_review drawers — once the host is paused,
// the message about *needing to pause* is irrelevant and the footer buttons
// already communicate the next step.
export default function LiveEditPolicyCard() {
    return (
        <div className="drawer-live-policy-card">
            <div className="drawer-live-policy-card-title">
                Editing this listing
            </div>
            <div className="drawer-live-policy-card-body">
                You can update the hourly rate, parking instructions,
                availability, amenities, photos, and blackout dates right here while the
                listing stays live.
                <br />
                <br />
                Other fields — the geofence, address, insurance, property
                name, and property type — can only be changed while the
                listing is <strong>paused</strong>. After editing those, your
                changes need ParkPro approval before the listing can go
                live again.
            </div>
        </div>
    );
}
